import { Box, Tab, Tabs } from "@mui/material";
import { useAtom } from 'jotai';
import { FC, useEffect, useState } from "react";
import { permissionsAtom } from '../../atoms/atom';
import AppBar from "../../components/app-bar/AppBar";
import FinancialDocuments from '../../components/financial/documents/FinancialDocuments';
import FinancialIndicators from '../../components/financial/indicators/FinancialIndicators';
import FinancialOverview from '../../components/financial/overview/FinancialOverview';
import FinancialReview from '../../components/financial/review/FinancialReview';
import { useUtils } from '../../utils/utilFunctions';
import "./Financial.scss";

const Financial: FC = () => {
	const [section, setSection] = useState<string>("OVERVIEW");
	const [permissions] = useAtom(permissionsAtom);
	const { verifyPermission } = useUtils();

	useEffect(() => {
		if (!!permissions.length) {
			verifyPermission(permissions, 'FINANCIAL');
		}
	}, []);

	return (
		<>
			<AppBar
				modulo="Financeiro"
			/>
			<div className="financeiro">
				<Tabs
					value={section}
					onChange={(_, value) => setSection(value)}
					variant="scrollable"
					scrollButtons="auto"
					aria-label="Financeiro"
					sx={{ borderBottom: 1, borderColor: 'divider', width: '100%' }}
				>
					<Tab label="Visão geral" value="OVERVIEW" />
					<Tab label="Conferência" value="REVIEW" />
					<Tab label="Documentos/Arquivos" value="DOCUMENTS" />
				</Tabs>
				{section === 'OVERVIEW' && <FinancialIndicators />}
				<Box className="card">
					{section === 'OVERVIEW' && <FinancialOverview />}
					{section === 'REVIEW' && <FinancialReview />}
					{section === 'DOCUMENTS' && <FinancialDocuments />}
				</Box>
			</div>
		</>
	);
}

export default Financial
